// Utility per gestire il document.title e i meta tag dinamicamente
// Questa è un'alternativa a react-helmet per React 19

const updateMetaTags = (metadata) => {
  // Aggiorna il titolo della pagina
  if (metadata.title) {
    document.title = metadata.title;
  }

  // Aggiorna la descrizione
  const descriptionTag = document.querySelector('meta[name="description"]');
  if (descriptionTag && metadata.description) {
    descriptionTag.setAttribute('content', metadata.description);
  }

  // Aggiorna i meta tag per Open Graph
  if (metadata.ogTitle) {
    let ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute('content', metadata.ogTitle);
    }
  }

  if (metadata.ogDescription) {
    let ogDescTag = document.querySelector('meta[property="og:description"]');
    if (ogDescTag) {
      ogDescTag.setAttribute('content', metadata.ogDescription);
    }
  }

  if (metadata.ogImage) {
    let ogImageTag = document.querySelector('meta[property="og:image"]');
    if (ogImageTag) {
      ogImageTag.setAttribute('content', metadata.ogImage);
    }
  }

  if (metadata.ogUrl) {
    let ogUrlTag = document.querySelector('meta[property="og:url"]');
    if (ogUrlTag) {
      ogUrlTag.setAttribute('content', metadata.ogUrl);
    }
  }

  // Aggiorna i meta tag per Twitter
  if (metadata.twitterTitle) {
    let twitterTitleTag = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitleTag) {
      twitterTitleTag.setAttribute('content', metadata.twitterTitle);
    }
  }

  if (metadata.twitterDescription) {
    let twitterDescTag = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescTag) {
      twitterDescTag.setAttribute('content', metadata.twitterDescription);
    }
  }

  if (metadata.twitterImage) {
    let twitterImageTag = document.querySelector('meta[property="twitter:image"]');
    if (twitterImageTag) {
      twitterImageTag.setAttribute('content', metadata.twitterImage);
    }
  }
};

export default updateMetaTags;
